import React from 'react';
import {
  Field,
  WrappedFieldInputProps,
  WrappedFieldMetaProps
} from 'redux-form';
import SelectFieldComponent from '../../../../forms/helpers/fields/SelectFieldComponent';
import { MetadataFormFieldRow } from '@cube3/ui/src/metadata/MetadataFormField';
import { Typography } from '@cube3/ui/src/typography/Typography';
import { dateParser } from '@cube3/forms/src/utils/makeParser';
import DatePicker from '@cube3/forms/src/fields/DatePicker';
import { makeCSS } from '@cube3/cubicle/src/utils/makeCSS';
import { isMobile } from 'react-device-detect';
import { DatePickerField } from './ContractDurationField';

interface Props extends WrappedFieldInputProps, WrappedFieldMetaProps {
  note?: string;
}

const useCSS = makeCSS(({ theme }) => {
  return {
    mobileStyle: {
      display: 'flex',
      width: 'calc(100vw - 50px)',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginTop: theme.spacing[3]
    }
  };
});

const options = ['Workspace defaults', 'Custom date'];
const parser = (val) => val === 'Custom date';
const formatter = (val) => (val ? 'Custom date' : 'Workspace defaults');

export const ContractReminderField: React.FunctionComponent<Props> = (
  props
) => {
  const { name, value, error, note } = props;

  const classes = useCSS();

  return (
    <>
      <Field
        name={`${name}.override_date`}
        component={(props) => (
          <SelectFieldComponent
            {...props}
            data-cy="select-new-contract-reminder-type"
          />
        )}
        options={options}
        format={formatter}
        parse={parser}
      />

      {value?.override_date && (
        <div className={isMobile ? classes.mobileStyle : ''}>
          <Field
            name={`${name}.remind_at`}
            component={DatePickerField}
            props={{
              minDate: value?.expires_at || undefined,
              label: 'Reminder date',
              isNested: true,
              'data-cy': 'date-picker-remind-date',
              required: true
            }}
            validate={(val) => (!val ? 'required' : undefined)}
            parse={dateParser}
          />
        </div>
      )}
      {error && (
        <Typography color="danger1">Please fill out the date</Typography>
      )}
    </>
  );
};
